export enum EFiltersRefinement {
	SIZE = 'c_size',
	COLORS = 'c_colorDescription',
	COLORS_HEX = 'c_hexadecBasicColor',
	CATEGORY = 'c_categoryFilter',
	COLORDATA = 'colorData',
}
